// Common
export const FETCH_END = 'FETCH_END';
export const FETCH_START = 'FETCH_START';

// Auth
export const PURGE_AUTH = 'PURGE_AUTH';
export const SET_AUTH = 'SET_AUTH';
export const SET_ERROR = 'SET_ERROR';
export const RESET_STATE = 'RESET_STATE';

// Settings
export const SET_NAVBAR_STATE = "SET_NAVBAR_STATE";
export const NAVBAR_TOGGLE = "NAVBAR_TOGGLE";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const UPDATE_LOADING_SETTINGS_STATE = "UPDATE_LOADING_SETTINGS_STATE";

// Devices
export const UPDATE_LIST_OF_DEVICES = 'UPDATE_LIST_OF_DEVICES';
export const UPDATE_SINGLE_DEVICE = 'UPDATE_SINGLE_DEVICE';
export const RESET_SINGLE_DEVICE_STATE = 'RESET_SINGLE_DEVICE_STATE';
export const UPDATE_LOADING_DEVICE_STATE = 'LOADING_DEVICE_STATE';
export const UPDATE_DEVICES_FILTER = 'UPDATE_DEVICES_FILTER';
export const UPDATE_DEVICE_COUNT = 'UPDATE_DEVICE_COUNT';
export const UPDATE_LOADING_REFRESH_RATE = 'UPDATE_LOADING_REFRESH_RATE';
export const UPDATE_DEVICE_LOCATIONS = 'UPDATE_DEVICE_LOCATIONS';
export const UPDATE_DEVICE_MOVE_DETAILS = 'UPDATE_DEVICE_MOVE_DETAILS';
export const SET_MOVE_LOADING = 'SET_MOVE_LOADING';
export const UPDATE_DEVICES_USAGE = 'UPDATE_DEVICES_USAGE';
export const SET_LOCATIONS_LOADING = 'SET_LOCATIONS_LOADING';
export const UPDATE_DEFAULT_DEVICE_REFRESH_RATE = 'UPDATE_DEFAULT_DEVICE_REFRESH_RATE';
export const RESET_DEVICE_FILTER = 'RESET_DEVICE_FILTER';

// Moves
export const UPDATE_LIST_OF_MOVES = 'UPDATE_LIST_OF_MOVES';
export const UPDATE_MOVES_PARAMS = 'UPDATE_MOVES_PARAMS';
export const UPDATE_MOVES_COUNT = 'UPDATE_MOVES_COUNT';
export const RESET_MOVE_PARAMS = 'RESET_MOVE_PARAMS';
export const UPDATE_LOADING_MOVES_STATE = 'UPDATE_LOADING_MOVES_STATE';
export const UPDATE_SINGLE_MOVE = 'UPDATE_SINGLE_MOVE';

// Notifications
export const UPDATE_LIST_OF_NOTIFICATIONS = 'UPDATE_LIST_OF_NOTIFICATIONS';
export const EXTEND_LIST_OF_NOTIFICATIONS = 'EXTEND_LIST_OF_NOTIFICATIONS';
export const UPDATE_TOTAL_NOTIFICATIONS_COUNT = 'UPDATE_TOTAL_NOTIFICATIONS_COUNT';
export const UPDATE_TOTAL_NOT_READ_NOTIFICATIONS_COUNT = 'UPDATE_TOTAL_NOT_READ_NOTIFICATIONS_COUNT';
export const UPDATE_NOTIFICATION_PARAMS = 'UPDATE_NOTIFICATION_PARAMS';
export const RESET_NOTIFICATION_PARAMS = 'RESET_NOTIFICATION_PARAMS';
export const UPDATE_HAS_MORE_TO_LOAD = 'UPDATE_HAS_MORE_TO_LOAD';
export const UPDATE_CHECK_NOT_READ_NOTIFICATIONS_COUNT = 'UPDATE_CHECK_NOT_READ_NOTIFICATIONS_COUNT';
